import { isEmpty } from 'lodash-es';
import { Dispatch, SetStateAction, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useSearchParams } from 'react-router-dom';
import { uploadFileToS3, saveDocuments, CandidateResume } from 'wisestep-api';

import { success, warning } from '../../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../../utils/NotificationStore';

import UploadDialog from './UploadDialog';

const UploadFile = ({
  open,
  setOpen,
  disableSelectCatagory = false,
}: {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  disableSelectCatagory?: boolean;
}) => {
  const methods = useForm({ defaultValues: { documentType: 'CV' } });
  const [params] = useSearchParams();
  const [document, setDocument] = useState<CandidateResume>({} as CandidateResume);
  const setNotification = useNotificationStore((state) => state.setNotification);
  const uploadFile = async (file: File[]) => {
    const response = await uploadFileToS3(file[0]);
    setDocument((state) => ({
      ...state,
      resumeLocation: response.split('?')[0],
      resumeUploadedOn: new Date(),
      candidateId: (params.get('id') as string) ?? '',
      resumeFileName: file[0]?.path ?? '',
      resumeFileType: methods.getValues('documentType'),
    }));
  };
  const saveAction = async () => {
    if (isEmpty(document)) {
      setNotification(warning('Please upload a file!'));
      return;
    }
    try {
      await saveDocuments([document]);
      setNotification(success('File Uploaded Successfully!'));
    } catch (e) {
      console.error(e);
      setNotification(warning('Error occured while File uploading!'));
    } finally {
      handleClose();
    }
  };
  const handleClose = () => {
    setOpen(false);
    setDocument({} as CandidateResume);
  };
  return (
    <FormProvider {...methods}>
      <UploadDialog
        document={document}
        uploadFile={uploadFile}
        name="documentType"
        open={open}
        handleClose={handleClose}
        saveAction={saveAction}
        removeDocument={() => setDocument({} as CandidateResume)}
        disableSelectCatagory={disableSelectCatagory}
      />
    </FormProvider>
  );
};
export default UploadFile;
